import { MuxVideo } from "./mux-video"
import { User } from "./user"

// High-level generic status that applies to all providers
export enum NotetakerStatus {
  SCHEDULED = "scheduled",
  CONNECTING = "connecting",
  ACTIVE = "active",
  PROCESSING = "processing",
  COMPLETED = "completed",
  ERROR = "error",
  UNKNOWN = "unknown",
}

export interface TranscriptWord {
  text: string
  start_timestamp: {
    absolute: string
    relative: number
  }
  end_timestamp: {
    absolute: string
    relative: number
  }
}

export interface TranscriptParticipant {
  id: string | number
  name: string
  is_host: boolean
  platform: string
  extra_data: Record<string, unknown>
}

export interface TranscriptEntry {
  words: TranscriptWord[]
  participant: TranscriptParticipant
}

export interface TranscriptSpeaker {
  id: string
  guid: string
  provider_id: string
  original_name: string
  overridden_name: string | null
  effective_name: string
}

export interface RawNotetaker {
  id: string
  name: string
  meeting_link: string
  status: string
  provider_state: string
  provider_subcode: string | null
  join_time: Date
  created_at: Date
  updated_at: Date
  user: User
  provider?: string
  calendar_event?: {
    id: string
    title: string
    start_time: Date
    end_time: Date
    html_link: string
    meeting_link: string
  }
  mux_video?: MuxVideo
  duration_seconds?: number
  retention_mode?: string
  retention_days?: number | null
  purge_after_at?: Date | null
  completed_at?: Date | null
  media_purged_at?: Date | null
}

export interface Notetaker {
  id: string
  name: string
  meetingLink: string
  status: NotetakerStatus
  providerState: string
  providerSubcode: string | null
  joinTime: Date
  createdAt: Date
  updatedAt: Date
  user: User
  provider?: NotetakerProvider
  duration_seconds?: number
  muxVideo?: MuxVideo
  retentionMode?: string
  retentionDays?: number | null
  purgeAfterAt?: Date | null
  completedAt?: Date | null
  mediaPurgedAt?: Date | null
}

export enum NotetakerProvider {
  NYLAS = "nylas",
  RECALL = "recall",
}
